import styled from 'styled-components';

export const Text = styled.p`
    margin-bottom: 20px;
`;

export const Buttons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 20px;
`;
